import { Button, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Страница которую вы запрашиваете не найдена."
      extra={
        <Button onClick={() => navigate(-1)} type="primary">
          Назад
        </Button>
      }
    />
  );
}

export { NotFoundPage };
